/* eslint-disable sort-keys-fix/sort-keys-fix */
export default {
    sm: '0.8rem',
    md: '1rem',
    lg: '1.7rem',
    xl: '2.2rem',
};
